import { observable } from '@/libs/state'

// UI state for the work-item detail view (page + sheet). Kept in a store so the
// page can be split into focused components - header, main, sidebar, dialogs -
// that each subscribe to only the flags they render, instead of one monolithic
// component threading dialog/composer state through props.
const showCancel$ = observable<boolean>(false)
const showReject$ = observable<boolean>(false)
const showArchive$ = observable<boolean>(false)

const cancelReason$ = observable<string>('')
const rejectReason$ = observable<string>('')
const commentBody$ = observable<string>('')
const labelDraft$ = observable<string>('')

const resetWorkItemComposers = () => {
	showCancel$.set(false)
	showReject$.set(false)
	showArchive$.set(false)
	cancelReason$.set('')
	rejectReason$.set('')
	commentBody$.set('')
	labelDraft$.set('')
}

export {
	showCancel$,
	showReject$,
	showArchive$,
	cancelReason$,
	rejectReason$,
	commentBody$,
	labelDraft$,
	resetWorkItemComposers,
}
